import type { EventDetailSectionProps } from '@/features/publicsite/types/events/EventDetailSectionProps';

/** One titled section of the event card; `lang` marks the text, the heading is the page's own. */
export function EventDetailSection({ heading, lang, children }: EventDetailSectionProps) {
  return (
    <section className="event-detail__section">
      <h2 className="event-detail__section-heading">{heading}</h2>
      {/* pre-line, because these fields are free text an organiser typed with their own line
        breaks; collapsing them would run an agenda's items into one paragraph. */}
      <p className="event-detail__prose" lang={lang}>
        {children}
      </p>
    </section>
  );
}
